module.exports = __webpack_public_path__ + "static/HTB_homepage-animation_v8-646ffe8791decca58a00d0655f68bf72.mp4";